import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-dot",
  "use": "icon-ib-dot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-dot\">\r\n    <path d=\"M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384z\" p-id=\"11130\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol